import { Avatar, Badge, Card } from '@/shared/ui';
import type { GroupView } from '../model/drawView';

export interface GroupCardProps {
  title: string;
  /** Skład grupy po losowaniu; bez niego karta rysuje miejsca do wylosowania. */
  group?: GroupView;
  /** Liczba pustych miejsc w podglądzie przed losowaniem. */
  placeholderSlots?: number;
  placeholderLabel?: string;
  /** Etykieta postępu meczów w prawym górnym rogu, np. „3 / 6 meczów”. */
  matchesLabel?: string;
}

/** Karta grupy — skład po losowaniu albo miejsca do wylosowania w podglądzie. */
export function GroupCard({
  title,
  group,
  placeholderSlots,
  placeholderLabel,
  matchesLabel,
}: GroupCardProps) {
  return (
    <Card padding="md" className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-fg-strong text-sm font-bold tracking-[0.04em] uppercase">{title}</h3>
        {matchesLabel && (
          <Badge tone="neutral" size="sm">
            {matchesLabel}
          </Badge>
        )}
      </div>

      {group ? (
        <ol className="flex flex-col">
          {group.members.map((member, index) => (
            <li
              key={member.ids.join('+')}
              className="border-border flex items-center gap-2.5 border-b py-2 last:border-b-0"
            >
              <span className="text-fg-subtle w-5 shrink-0 text-right text-xs tabular-nums">
                {index + 1}
              </span>
              <Avatar name={member.label} size="xs" colorful />
              <span className="text-fg min-w-0 flex-1 truncate text-sm font-medium">
                {member.label}
              </span>
              {member.seed !== null && (
                <Badge tone="brand" shape="square" size="sm">
                  {member.seed}
                </Badge>
              )}
            </li>
          ))}
        </ol>
      ) : (
        <div className="flex flex-col gap-1.5">
          {Array.from({ length: placeholderSlots ?? 0 }, (_, index) => (
            <div
              key={index}
              className="border-border bg-surface-sunken/50 text-fg-subtle rounded-lg border border-dashed px-3 py-2 text-xs"
            >
              {placeholderLabel}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
